export enum RaceStatuses {
  Open,
  Abandoned,
  Released,
  Interim,
  Closed,
}
